/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IAdditionalTimeRequest } from '../models/additional-time.model';

export class CreateAdditionalTime {
  static readonly type = '[AdditionalTimes] Create Additional Time';
  constructor(public additionalTime: IAdditionalTimeRequest) {}
}

export class ApproveAdditionalTime {
  static readonly type = '[AdditionalTimes] Approve Additional Time';
  constructor(public ids: string[]) {}
}

export class DenyAdditionalTime {
  static readonly type = '[AdditionalTimes] Deny Additional Time';
  constructor(public ids: string[]) {}
}

export class LoadAdditionalTimeRequests {
  static readonly type = '[AdditionalTimes] Load Additional Time Requests';
  constructor(public filter?: MainTableFilterModel) {}
}

export class LoadAdditionalTimeRequestsForUser {
  static readonly type = '[AdditionalTimes] Load Additional Time Requests For User';
  constructor(public filter?: MainTableFilterModel) {}
}
